import { SVGProps, Ref, forwardRef } from 'react';

export const QuestionCircleFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 .5C2.375.5.5 4.25.5 8s1.875 7.5 7.5 7.5 7.5-3.75 7.5-7.5S13.625.5 8 .5m-.002 4.532c-.704 0-1.133.438-1.133.966h-1.4c0-1.47 1.237-2.366 2.533-2.366s2.533.895 2.533 2.366c0 .562-.16 1.002-.427 1.358-.236.314-.539.535-.753.69l-.025.018c-.243.177-.383.285-.482.416-.077.103-.146.246-.146.518h-1.4c0-.562.16-1.002.426-1.358.236-.314.54-.534.753-.69l.026-.018c.243-.177.383-.285.481-.416.078-.103.147-.246.147-.518 0-.528-.43-.966-1.133-.966m0 4.866a.933.933 0 1 1 0 1.866.933.933 0 0 1 0-1.866"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
QuestionCircleFilledSize16Glyph.displayName = 'QuestionCircleFilledSize16Glyph';
